<template>
    <div class="prelogSummary">

        <section class="toolbar">
            <div class="toolbar-container">
                <router-link id="back-button-pre-log-summary" v-bind:to="'/operator/home-page'"><img src="/static/images/back.png"></router-link>
                <h1><label>{{ formattedDate }} Logs</label></h1>
            </div>
        </section>

        <div class="clearfix"></div>
        <section class="tab-container">
            <div id="custom-tab">
                <ul class="nav nav-pills">
                    <li id="pre-log-summary-log-tab" class="active">
                        <a href="#log" data-toggle="tab">Log</a>
                    </li>
                    <li id="pre-log-summary-sign-tab">
                        <a href="#sign" data-toggle="tab" id="sign_tab">Sign</a>
                    </li>
                    <li id="pre-log-summary-inspection-tab">
                        <a  href="#inspection" data-toggle="tab" id="inspection_tab">Inspection</a>
                    </li>
                </ul>
                <div class="tab-content clearfix">
                    <div class="tab-pane active" id="log">
                        <section class="list-view">
                            <div class="list-view-title">
                                <h2>Summary</h2>
                            </div>
                            <div class="list-container">
                                <div class="accordian-container">
                                    <div class="panel-group" id="accordion">
                                        <div v-for="(val,key) in items" v-bind:key="key" class="panel panel-default">
                                            <div class="panel-heading">
                                                <h4 class="panel-title">
                                                    <a :id="'pre-log-summary-accordion-'+key" class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" v-bind:href="'#'+key">
                                                        <ul>
                                                            <li>
                                                                <div class="list-view-left">{{ key }}</div>
                                                            </li>
                                                        </ul>
                                                    </a>
                                                </h4>
                                            </div>
                                            <div v-bind:id="key" class="panel-collapse collapse">
                                                <div class="panel-body">
                                                    <div class="accordion-internal-container">
                                                        <div v-for="(obj,index) in val" v-bind:key="index" class="accordion-internal-container-block">
                                                            <div class="pull-left">{{ obj.key }}</div>
                                                            <div class="pull-right">{{ obj.value }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- end container -->
                            </div>
                                <!-- <highcharts :options="options"></highcharts> -->
                            <div class="clearfix"></div>
                            <div class="section-chart">
                                <div id="container"></div>
                            </div>
                        </section>
                        <div class="floating-btn">
                            <router-link id="edit-logs-prelogsummary" v-bind:to="'/operator/edit-log?selected_date='+selected_date+'&from_date=' + fromDate + '&to_date=' + toDate">
                                <a href="#">
                                    <img src="/static/images/edit-white.png" alt="e">
                                </a>
                            </router-link>
                        </div>
                    </div>
                    <div class="tab-pane" id="sign">
                        <section class="signature-pad">
                            <template v-if="signReceived">
                                <img v-if="signReceived" :src="sign_image" id="sig_img" alt="unable to load image">    
                            </template>
                            <template v-else>
                                <template v-if="showSignCanvas">
                                    <div class="form-group">
                                        <canvas id="signature-pad-driver" class="signature-pad col-md-12" height=200></canvas>
                                        <label for="comment" class="pull-right" id="clear" v-on:click="signaturePadDriver.clear()">Clear Signature</label>
                                    </div>
                                    <div class="inspection-btn-container" v-on:click="uploadSignLog()">
                                        <a href="#" class="inspection-btn">Upload Sign</a>
                                    </div>
                                </template>
                                <template v-else-if="!showSignCanvas">
                                    Logs Not Signed Yet
                                    <div id="pre-log-summary-signlog" class="inspection-btn-container" v-on:click="enableCanvas()">
                                        <a href="#" class="inspection-btn">Sign Logs</a>
                                    </div>
                                </template>
                            </template>
                        </section>
                    </div>
                    <div class="tab-pane" id="inspection">
                        <!--<label>Inspection Tab</label>
                        <router-link v-bind:to="'/asset/inspection?selected_date='+selected_date" tag="button" class="btn btn-primary bmd-btn-fab"></router-link>
                        <i class="material-icons">grade</i>
                        </button>-->
                        <div v-for="(val,index) in inspectionList" :id="'inspection_' + val.id" class="defects-internal-container">
                            <div class="defect-internal-top">
                                <div class="left">
                                    <div class="left-block">
                                        <img src="/static/images/clock.png">
                                        {{ val.inspection_time }}
                                    </div>
                                    <div class="left-block location-image">
                                        <img src="/static/images/location-gray.png">
                                        {{ val.location_name }}
                                    </div>
                                </div>
                                <div class="right">
                                    <a :id="'delete-inspection-'+index" href="#" v-on:click="promptDelete(val.id)">
                                        <img src="/static/images/delete.png">
                                    </a>                                    
                                    <router-link :id="'edit-inspection-'+index" v-bind:to="'/asset/inspection/'+val.id+'?selected_date='+selected_date" >
                                        <img src="/static/images/edit.png">
                                    </router-link>
                                    
                                </div>
                            </div>
                            <div class="defects-vehicles-block">
                                <div class="defects-vehicles-number">
                                Vehicle {{ val.vin + " ("+ val.unit_number_id +")"}}
                                </div>
                                <ul>
                                    <li v-for="vehcileDefect in val.vehicle_defects">
                                        <div class="details-block">
                                        <div class="details-label first-label">{{ vehcileDefect.defect_name }}</div>
                                        <div class="details-notes">
                                            <span v-if="vehcileDefect.defect_type == 'major'" class="major">{{ vehcileDefect.defect_type | capitalize}}</span>
                                            <span v-else class="minor">{{ vehcileDefect.defect_type | capitalize}}</span>
                                        </div>
                                        </div>
                                        <div class="details-block">
                                        <div class="details-label">Defect Details</div>
                                        <div class="details-notes">
                                            {{ vehcileDefect.note }}
                                        </div>
                                        </div>
                                        <template v-if="vehcileDefect.image != ''">
                                            <div class="details-block">
                                                <div class="details-img">
                                                    <img :src="$config.API+'/'+vehcileDefect.image">
                                                </div>
                                            </div>
                                        </template>
                                    </li>
                                </ul>
                            </div>
                            <div class="defects-vehicles-block" v-if="val.trailer_defects != null && val.trailer_defects.length !=0 ">
                                <div class="defects-vehicles-number">
                                Trailers
                                </div>
                                <div class="defects-vehicles-input-block">
                                    <div class="group">      
                                        <input type="text" :value=val.trailer_numbers readonly>
                                        <span class="highlight"></span>
                                        <span class="bar"></span>
                                        <label>Trailers Numbers</label>
                                    </div>
                                </div>
                                <ul>
                                    <li v-for="trailerDefect in val.trailer_defects">
                                        <div class="details-block">
                                            <div class="details-label first-label">{{ trailerDefect.defect_name }}</div>
                                            <div class="details-notes">
                                                <span v-if="trailerDefect.defect_type == 'major'" class="major">{{ trailerDefect.defect_type | capitalize}}</span>
                                                <span v-else class="minor">{{ trailerDefect.defect_type | capitalize}}</span>
                                            </div>
                                        </div>
                                        <div class="details-block">
                                            <div class="details-label">Defect Details</div>
                                            <div class="details-notes">
                                                {{ trailerDefect.note }}
                                            </div>
                                        </div>
                                        <template v-if="trailerDefect.image != ''">
                                            <div class="details-block">
                                                <div class="details-img">
                                                    <img :src="$config.API+'/'+trailerDefect.image">
                                                </div>
                                            </div>
                                        </template>
                                    </li>
                                </ul>
                            </div>
                            <div v-show="val.defect_status != -1">
                                <div v-show="val.defect_status == 1" class="defect-status-correct">
                                    Defects Corrected
                                </div>
                                 <div v-show="val.defect_status == 0" class="defect-status-uncorrect">
                                    Defects Need Not Be Corrected
                                </div>
                            </div>
                            <div class="signature-bottom">
                                <span v-show="val.driver_sign !=''">
                                    <img src="/static/images/tick-color.png">
                                    Driver
                                </span>
                                <span v-show="val.mechanic_sign !=''">
                                    <img src="/static/images/tick-color.png">
                                    Mechanic
                                </span>
                            </div>  
                        </div>
                         <div class="floating-btn">
                            <router-link id="add-new-inspection" v-bind:to="'/asset/inspection?selected_date='+selected_date+'&from_date=' + fromDate + '&to_date=' + toDate">
                                <a href="#">
                                    +
                                </a>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--<section class="start-container">
            <div class="start-status vvg-fullwidth">
                <div class="pull-left">{{ selected_date }}</div>
                <div class="pull-right">{{ total_time }}</div>
            </div>
        </section>--> 
<div class="custom-loading" v-if="this.$config.loading">
      <div class="custom-loading-box">
         <i class="fa fa-truck faa-passing-reverse animated " aria-hidden="true"></i>
      </div>
      </div>
    </body>
  </div>

    </div>
</template>

<script>

import Highcharts from "highcharts";
import SignaturePad from 'signature_pad';
// import { accordion } from 'vue-strap';
// var acordion = require('vue-strap').accordion;
export default {
    //   components: {
    //     accordion : acordion
    //   },
    name: "prelogSummary",
    data: () => ({
        labelArray: ['', 'ON', 'D', 'SB', 'OFF'],
        startX: 0,
        startY: 0,
        selected_date: "",
        fromDate:"",
        toDate:"",
        formattedDate: "",
        total_time: "",
        sign_image: "",
        items: {},
        graph_data: {},
        total_hours: {},
        signReceived: false,
        inspectionList: [],
        showTrailerDefects: false,
        showVehicleDefects: false,
        serverPath: "",
        vl_plot:{},
        showSignCanvas: false,
    }),
    mounted: function() {
        this.selected_date = this.$route.query.selected_date;
        this.fromDate = this.$route.query.from_date;
        this.toDate = this.$route.query.to_date;
        this.formattedDate = this.frontEndDateFormat();
        this.serverPath = this.$config.API;
        this.getUserAgent();
        this.call();
        console.log()
        if( this.userAgent == "vtrleld_app" ) {
            Native.disableSwipeRefresh();
        }
    },
    beforeDestroy: function() { },
    methods: {
        getUserAgent : function() {
            this.userAgent = navigator.userAgent;
            console.log("UserAgent : " +  this.userAgent);
        },
        call: function() {
            var self = this;self.$config.loading=true;
            $.ajax({
                url:self.$config.API+"/v1/operator/pre-log-summary?date=" + self.$route.query.selected_date + "&from_date=" + self.fromDate + "&to_date=" + self.toDate,
                type: "GET",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },timeout: 10000,
                success: function(res) {

                    if (res.status == "success") {

                        var data = res.data.logData;
                        
                        //self.selected_date = data.selected_date;
                        self.total_time = data.total_time;
                        self.sign_image = decodeURIComponent(data.sign_image);
                        console.log("Sign : " + self.sign_image)
                        self.items = data.items;
                        self.graph_data = data.graph_data;
                        self.total_hours = data.total_hours;
                        self.vl_plot = data.violation_plot;
                        //self.options.series.data = self.graph_data;
                        //self.updateFormatter();
                        if (self.sign_image == "") {
                            self.signReceived = false;
                            self.showSignCanvas = false;
                            //self.initSignPad();
                        } else {
                            self.signReceived = true;
                            self.showSignCanvas = false;
                        }                   
                        
                        // ***********************************************************************************************
                        var colors = Highcharts.getOptions().colors;
                        //console.log(dataArray);
                        Highcharts.chart('container', {
                            chart: {
                                type: 'line',
                                lineColor: colors[0],
                                plotBorderColor: '#346691',
                                plotBorderWidth: 2,
                                width: 1000
                                //plotBackgroundImage: 'https://www.highcharts.com/samples/graphics/skies.jpg',
                            },
                            credits: { enabled: false },
                            tooltip: { enabled: false },
                            rangeSelector: {
                                selected: 1
                            },
                            title: {
                                text: 'Log Timings'
                            },
                            plotOptions: {
                                line: {
                                    marker: {
                                        enabled: false
                                    },
                                    dataLabels: { enabled: false },
                                    enableMouseTracking: true,
                                    states: {
                                        select: {
                                            lineWidth: 10
                                        }
                                    },
                                    events: {
                                        click: function(e) {
                                            //console.log(e.point.options.x+ " " + e.point.options.y);
                                            console.dir(e);
                                            this.setState(this.state === 'select' ? '' : 'select');
                                        }
                                    }
                                },
                                series: {
                                    point: {
                                        events: {
                                            drag: function(e) {
                                                // Returning false stops the drag and drops. Example:
                                                /*
                                                if (e.newY > 300) {
                                                    this.y = 300;
                                                    return false;
                                                }
                                                */
                                                if (self.startX == 0) {
                                                    self.startX = this.x;
                                                }
                                                if (self.startY == 0) {
                                                    self.startY = this.y;
                                                }
                                                console.log(this.x + "," + self.startX);
                                                if (this.x < self.startX) {
                                                    this.x = self.startX;
                                                }
                                                if (this.y < 1) {
                                                    this.y = 1;
                                                    e.newY = 1;
                                                }
                                                if (this.y > 4) {
                                                    this.y = 4;
                                                    e.newY = 4;
                                                }
                                                $('#drag').html(
                                                    'Dragging <b>' + this.series.name + '</b> to <b>[' + Highcharts.numberFormat(e.newX, 2) + ', ' + Highcharts.numberFormat(e.newY, 2) + ']</b>');
                                            },
                                            drop: function() {
                                                $('#drop').html(
                                                    'Dropped <b>' + this.series.name + '</b> at <b>[' + Highcharts.numberFormat(this.x, 0) + ', ' + Highcharts.numberFormat(this.y, 0) + ']</b>');
                                            }
                                        }
                                    }
                                }
                            },
                            xAxis: {
                                type: 'time',
                                min: 0,
                                max: 24,
                                gridLineWidth: 1,
                                tickInterval: 1,
                                plotLines:self.vl_plot,                                
                                labels: {
                                    style: {
                                        fontSize: '14px',
                                    },
                                    formatter: function() {
                                        if (this.value == 0 || this.value == 24) {
                                            return "M";
                                        } else if (this.value == 12) {
                                            return "N";
                                        } else if (this.value > 12 && this.value < 24) {
                                            return (this.value - 12);
                                        } else {
                                            return this.value;
                                        }
                                    }
                                }
                            },
                            yAxis: [{
                                "title": {
                                    "text": "Duty Status",
                                    "align": "middle"
                                },
                                min: 0,
                                max: 5,
                                opposite: false,
                                showLastLabel: true,
                                labels: {
                                    formatter: function() {
                                        //console.log(labelArray[this.value]);
                                        return self.labelArray[this.value];
                                    }
                                },
                            }, {
                                classnName: '.highcharts-underline-hours-label',
                                "title": {
                                    "text": "Duty Hours",
                                    "align": "middle"
                                },
                                min: 0,
                                max: 5,
                                showLastLabel: true,
                                labels: {
                                    style: {
                                        fontSize: '14px',
                                        fontWeight: 'bold',
                                    },
                                    formatter: function() {
                                        /*if(obj["'"+this.value+'"'] != null){
                                           return secondsToHms(obj['"'+this.value+'"'].TotalShiftTime);
                                        }*/
                                        if (this.value == 0) {
                                            return self.secondsToHms(self.total_hours["0"].TotalShiftTime);
                                        } else if (this.value == 1) {
                                            return self.secondsToHms(self.total_hours["1"].TotalShiftTime);
                                        } else if (this.value == 2) {
                                            return self.secondsToHms(self.total_hours["2"].TotalShiftTime);
                                        } else if (this.value == 3) {
                                            return self.secondsToHms(self.total_hours["3"].TotalShiftTime);
                                        } else if (this.value == 4) {
                                            return self.secondsToHms(self.total_hours["4"].TotalShiftTime);
                                        }
                                        return '';
                                    }
                                },
                                opposite: true,
                            }],
                            series: [{
                                //keys: ['y', 'id'],
                                type: 'line',
                                name: 'Log Timings',
                                data: self.graph_data/*[[0,1],[0.5,1], [1,1], [2,1],[2.5,2], [3,1], [4,1], [5,2],[6,2], [7,2], [8,2], [9,2], [10,2], [11,2],[12,2]
                            , [13,3], [14,3], [15,3], [16,3], [17,3],[18,3], [19,3], [20,3], /*[21,1], [22,1]
                            , [23,1],[24,2]]*/,
                                step: true,
                                tooltip: {
                                    valueDecimals: 4
                                },
                                cursor: 'move',
                                draggableX: false,
                                draggableY: false,
                                draggableSeries: false,
                                /*zoneAxis: 'x',
                                zones:[{
                                    value: 12,
                                    color: colors[0]
                                },{
                                    value: 18,
                                    color: colors[1]
                                }]*/
                            }]
                        }, function(chart) {
                            /*
                                Comparing Selected Date with Current Date to decide whether text should be rendered for a Time Interval or not.
                                If same no need to show Time Interval as we are not showing line in that case.
                                Else draw Text.
                            */
                            /*var d1 = new Date().setHours(0,0,0,0);
                            var d2 = new Date(self.fromDate).setHours(0,0,0,0);
                            var same = d1.valueOf() === d2.valueOf();
                            var dataPointsArray = chart.series[0].data;
                            console.log(d1, d2, same);
                            for (var i = 0; i < dataPointsArray.length; i++) {
                                //console.log(dataPointsArray[i]);
                                if (i == dataPointsArray.length - 1) {
                                    var point1 = dataPointsArray[i];//chart.series[0].data[i],
                                    if ((24 - point1.options.x) > 0 && !same) {
                                        var time = parseFloat(Math.round((24 - point1.options.x) * 100) / 100).toFixed(2)
                                        var text = chart.renderer.text(
                                            ((24 - point1.options.x).toFixed(2)).toString(),
                                            point1.plotX + chart.plotLeft + 50,
                                            point1.plotY + chart.plotTop - 10
                                        ).attr({
                                            zIndex: 5
                                        }).css({
                                            color: '#4572A7',
                                            fontSize: '16px'
                                        }).add();
                                        //console.log("Last Annotations : "+ (24-point1.options.x).toString());
                                    }
                                } else {
                                    var point1 = dataPointsArray[i];
                                    var nextVal = i + 1;
                                    var point2 = dataPointsArray[nextVal];
                                    if ((point2.options.x - point1.options.x) > 0) {
                                        var time = parseFloat(Math.round((point2.options.x - point1.options.x) * 100) / 100).toFixed(2)
                                        var text = chart.renderer.text(
                                            time.toString(),
                                            point1.plotX + chart.plotLeft + (point2.options.x - point1.options.x) * 25,
                                            point1.plotY + chart.plotTop - 10
                                        ).attr({
                                            zIndex: 5
                                        }).css({
                                            color: '#4572A7',
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                        }).add();
                                        //console.log("Annotations : " + (point2.options.x-point1.options.x).toString());
                                    }
                                }

                            }*/
                            //box = text.getBBox();    
                        });
                        // ***********************************************************************************************
self.loadInspections();
                    }

                },
                error: function(jqXHR, exception, textstatus) {self.$config.loading=false;
                    //if session expired
                    if(textstatus==="timeout") {
            alert("Request timeout");
        } else if (jqXHR.responseJSON.code == 401) {
                        self.$router.push(
                            "/v1/operator/login"
                        )
                    } else if ( jqXHR.responseJSON.code == 400 ) {
                        alert(jqXHR.responseJSON.messge);
                    }

                }
            });
        },
        enableCanvas: function() {
            this.showSignCanvas = !this.showSignCanvas;
            var self = this;
            setTimeout(function(){
                self.initSignPad();
            }, 50);
            //this.initSignPad();
        },
        initSignPad:function() {
            console.log("herer");
            this.signaturePadDriver = new SignaturePad(document.getElementById("signature-pad-driver"), {
                    backgroundColor: "rgba(255, 255, 255, 0)",
                    penColor: "rgb(0, 0, 0)"
                }
            );
        },
        loadInspections: function() {
            var self = this;
            $.ajax({
                url: self.$config.API+"/v1/assets/get-inspection-for-date?selected_date="+self.selected_date,
                type: "GET",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },timeout: 10000,
                dataType: "json",
                success: function(res) {self.$config.loading=false;
                    var data = res.data;
                    console.log(data);
                    //alert("Data : " + data);
                    if ( res.status == "success" ) {
                        
                        if (data.inspection_list != null && data.inspection_list.length > 0) {
                            self.inspectionList = data.inspection_list;
                        } else {
                            self.inspectionList = false;
                        }
                    }
                },
                error: function(jqXHR, exception, textstatus) {self.$config.loading=false;
                //if session expired
                if(textstatus==="timeout") {
            alert("Request timeout");
        } else if ( jqXHR.responseJSON.code == 401 ) {
                    self.$router.push(
                    "/v1/operator/login"
                    )  
                } else if ( jqXHR.responseJSON.code == 400 ) {
                    alert(jqXHR.responseJSON.messge);
                }
                    
                }
            });
        },
        promptDelete: function(inspectionId) {
            var result = confirm("Are you sure to delete this Inspection? ");
            if (result) {
                var self = this;self.$config.loading=true;
                $.ajax({
                    url: self.$config.API+"/v1/assets/delete-inspection?inspection_id="+inspectionId,
                    type: "POST",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },timeout: 10000,
                    dataType: "json",
                    success: function(res) {self.$config.loading=false;
                        var data = res.data;
                        console.log(data);
                        if ( res.status == "success" ) {
                            $("#inspection_"+inspectionId).remove();
                        } else {
                            alert("There was an error deleting Inspection. Please try again");
                        }
                    },
                    error: function(jqXHR, exception, textstatus) {self.$config.loading=false;
                    //if session expired
                    if(textstatus==="timeout") {
            alert("Request timeout");
        } else if ( jqXHR.responseJSON.code == 401 ) {
                        self.$router.push(
                        "/v1/operator/login"
                        )  
                    } else if ( jqXHR.responseJSON.code == 400 ) {
                        alert(jqXHR.responseJSON.messge);
                    }
                        
                    }
                });
            }
        },
        frontEndDateFormat: function() {
        	return moment(this.selected_date, 'YYYY-MM-DD').format('MM-DD-YYYY');
        },
        secondsToHms: function(d) {
            d = Number(d);
            var h = Math.floor(d / 3600);
            var m = Math.floor((d % 3600) / 60);
            var s = Math.floor((d % 3600) % 60);

            var hDisplay = h;
            var mDisplay = m;
            var sDisplay = s;
            return hDisplay + ":" + mDisplay; // + sDisplay;
        },
        uploadSignLog: function() {
            var self = this;
             if (self.signaturePadDriver.isEmpty()) {
                alert("Driver Signature required");
                return;
            }
            self.driverSignImage = self.signaturePadDriver.toDataURL("image/png");self.$config.loading=true;
            $.ajax({
                url: self.$config.API+"/v1/operator/upload-sign",
                type: "POST",
                data: {"sign_image": encodeURIComponent(self.driverSignImage), "selected_date": self.selected_date,"from_date": self.fromDate},
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },timeout: 10000,
                dataType: "json",
                success: function(res) {self.$config.loading=false;
                    alert("Logs Signed Successfully")
                    self.showSignCanvas = false;
                    self.signReceived = true;
                    self.sign_image = self.driverSignImage;
                },
                error: function(jqXHR, exception, textstatus) {self.$config.loading=false;
                    //if session expired
                if(textstatus==="timeout") {
            alert("Request timeout");
        } else if (jqXHR.responseJSON.code == 401) {
                        self.$router.push(
                            "/v1/operator/login"
                        )
                    } else if (jqXHR.responseJSON.code == 400) {
                        alert(jqXHR.responseJSON.message);
                    }
                }
            });
        },
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* .vvg-fullwidth{width:100%;} */

.highcharts-container {
    float: left;
    width: 100% !important;
    overflow-x: scroll !important;
}

.section-chart {
    float: left;
    width: 90%;
    margin: 0 5% 25px 5%;
    border: 1px solid #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/prelogSummary.vue